import type { Column } from '~/types/data-dictionary';

export const transformColumns = (
  columnsDictionary: Column[],
  localDictionary: DictionaryRow[]
): Column[] => {
  if (!localDictionary.length) return [...columnsDictionary];

  return columnsDictionary.map((col): Column => {
    const localDictionaryRow = localDictionary.find((row) => row.characteristic === col.key);

    return {
      ...col,
      label: localDictionaryRow?.abbreviation || col.label,
      enabledByDefault: 'enabledByDefault' in col ? col.enabledByDefault : true,
    };
  });
};
